import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';

/**
 * Returns a boolean if timeZone has changed,
 * if an optional newTimeZone param if provided
 * it doesn't use the option state.
 */
const hasTimeZoneChanged = (newTimeZone?: string) => {
    let optionState = getRegionalOptions();
    let { UserOptions } = getUserConfiguration();
    if (newTimeZone) {
        return newTimeZone != UserOptions.TimeZone;
    }
    return !!optionState.selectedTimeZone && optionState.selectedTimeZone != UserOptions.TimeZone;
};

export default hasTimeZoneChanged;
